// Pure (no imports) so it is testable without the API client.
export const SCORECARD_TAB = { key: "scorecard", label: "Owner scorecard", path: "/analytics/scorecard" };

/** Analytics sub-nav with the scorecard tab right after Overview when enabled. */
export const withScorecardTab = (tabs, enabled) => {
  const list = Array.isArray(tabs) ? tabs.filter((t) => t.key !== SCORECARD_TAB.key) : [];
  if (!enabled) return list;
  const i = list.findIndex((t) => t.key === "overview");
  const at = i === -1 ? 0 : i + 1;
  return [...list.slice(0, at), SCORECARD_TAB, ...list.slice(at)];
};
